import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { entryActionCustomValidateOptions } from '../../../../api/inbox';
import { UpdateFileEntryResponse } from '../../../../types';

const url = `${PREFIX_URL}/inbox-documents/:fileId/archive`;

export type MoveFileDTO = {
  fileId: number;
  newFolderId: number;
};

export const moveFile = ({
  fileId,
  newFolderId,
}: MoveFileDTO): Promise<UpdateFileEntryResponse> => {
  const URL = generateRoutePath(url, { fileId });

  return axios.post(
    URL,
    {
      'folder-id': newFolderId,
    },
    {
      ...entryActionCustomValidateOptions,
    }
  );
};

type useMoveFileOptions = {
  config?: MutationConfig<typeof moveFile>;
};

export const useMoveFile = ({ config }: useMoveFileOptions = {}) => {
  return useMutation({
    // onSuccess: (data) => {
    // },
    ...config,
    mutationFn: moveFile,
  });
};
